<template>
  <div class="double-good" @click="goDetail">
    <good-image
      :img-url="ssu.skuImg.imgUrl"
      :image-width="goodWidth"
      :stock-status="stockStatus"
      :is-video="isVideo"
      :layout-type="'double'"
      :custom-style="customImagStyle"
      :left-upper-tag="leftUpperTag"
      :sku-img="skuImg"
    />
    <div class="double-scroll-info">
      <base-info
        :custom-style="baseInfoStyle"
        :name="ssu.skuBase.skuName"
        :format-info="formatInfo"
        :ssu-fp-text="ssuFpText"
        :sku-attr-tags="filterSelfAttrTags"
      />
      <div class="discount-tag">
        <template v-if="disCountTag">
          <tag
            has-background
            :secondary-color="disCountTag.backgroundColor"
            :tag-style="disCountTagStyle"
            :font-size="12"
            :primary-color="disCountTag.textColor"
            :corner-radius="4"
            :use-trans-scale="false"
          >
            {{ disCountTag.tag }}
          </tag>
        </template>
        <template v-else-if="priceUpperFirstTag">
          <price-tag :tag="priceUpperFirstTag"></price-tag>
        </template>
      </div>

      <good-price
        :ssu="ssu"
        :common-tracer-pamas="commonTracerPamas"
        :ssu-info="ssuInfo"
        :custom-style="{ root: { marginTop: '0rem' } }"
        :show-original-price="showOriginalPrice"
        :custom-operator="customOperator"
        :use-icon="true"
        :show-discount="true"
        :show-discount-price="true"
        :show-dis-count-tag="showDisCountTag"
        :is-performance-type="isPerformanceType"
        show-green-card
        @addcart="addCartTrack"
        @goDetail="goDetail"
      />
    </div>
  </div>
</template>

<script>
import mixin from '../newMixin'
import Tag from '@/common/widgets/good_tag'
import PriceTag from '../widgets/price-tag.vue'
export default {
  name: 'NewDoubleGood',
  components: {
    Tag,
    PriceTag
  },
  mixins: [mixin],
  data() {
    return {
      customOperator: {
        simple: true,
        showPromoteTip: false,
        type: 'normal',
        useArrivedNoticeIcon: false
      },
      customImagStyle: {
        with: '1.20rem',
        height: '1.20rem'
      },
      baseInfoStyle: {
        root: {
          height: '0.7rem'
        }
      },
      disCountTagStyle: {
        padding: '1px 8px',
        'border-radius': '8px 4px 4px 0'
        // height: '16px',
        // lineHeight: '16px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.double-good {
  box-sizing: border-box;

  overflow: hidden;

  background-color: #fff;
  border-radius: 0.16rem;

  flex: none;
  @include flex(column, flex-start, flex-start, nowrap);
}
.double-scroll-info {
  position: relative;

  width: 100%;
  box-sizing: border-box;

  padding: 0 0.16rem 0.16rem 0.16rem;

  flex: auto;

  .discount-tag {
    height: 16px;

    margin-top: 6px;

    box-sizing: content-box;

    @include flex(row, flex-start, flex-start, wrap);
  }
}
</style>
